import { ConsoleLogger } from './ConsoleLogger';
import { Logger } from './Logger';

export class LoggerFactory {
	private static readonly loggerHolder: { logger: Logger } = { logger: console };

	static get logger(): Logger {
		return LoggerFactory.loggerHolder.logger;
	}

	static getLogger(category: string): Logger {
		return new ConsoleLogger(category);
	}

	static overrideLogger(logger: ConsoleLogger): void {
		LoggerFactory.loggerHolder.logger = logger;
	}
}
